/**
 * Custom Popup Product Information
 * Simple, standalone sliding drawer:
 * - toggles `is-open` on the target drawer
 * - adds/removes `js-drawer-open` on <body> for overlay/scroll-lock
 * - moves drawer to <body> on first open for proper stacking
 */
(function () {
  'use strict';

  function openDrawer(drawer) {
    if (!drawer) return;

    // Close any already-open popup drawer first
    var alreadyOpen = document.querySelector('[data-popup-info-drawer].is-open');
    if (alreadyOpen && alreadyOpen !== drawer) {
      alreadyOpen.classList.remove('is-open');
      alreadyOpen.setAttribute('aria-hidden', 'true');
    }
    // Move to body so the drawer sits above the theme overlay (z-index stacking)
    if (drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }

    // Ensure we always start from the "closed" position so the first open animates
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');

    // Force a layout so the browser applies the closed transform state
    // before we toggle to open. This is what guarantees the first click animates.
    void drawer.offsetWidth; // eslint-disable-line no-unused-expressions

    // Toggle to open on the next animation frame for a smooth transition
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('js-drawer-open');
      document.addEventListener('keyup', onEscape);
      // Delay outside-click listener so the opening click doesn't immediately close
      setTimeout(function () {
        document.addEventListener('click', onOutsideClick);
      }, 60);
    });
  }

  function closeDrawer() {
    var drawer = document.querySelector('[data-popup-info-drawer].is-open');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('js-drawer-open');
    document.removeEventListener('click', onOutsideClick);
    document.removeEventListener('keyup', onEscape);
  }

  function onEscape(e) {
    if (e.key === 'Escape') closeDrawer();
  }

  function onOutsideClick(e) {
    var openDrawerEl = document.querySelector('[data-popup-info-drawer].is-open');
    if (!openDrawerEl) return;
    // Click inside the drawer → ignore
    if (openDrawerEl.contains(e.target)) return;
    // Click on a trigger → ignore (will be handled by trigger listener)
    if (e.target.closest('[data-popup-info-trigger]')) return;
    closeDrawer();
  }

  function init() {
    // Run only once even if script is included multiple times (e.g. box + ingredient popup blocks)
    if (window.__popupInfoDrawerInit) return;
    window.__popupInfoDrawerInit = true;

    // Open: click on info icon [data-popup-info-trigger]
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-popup-info-trigger]');
      if (!trigger) return;
      var id = trigger.getAttribute('data-popup-info-trigger');
      if (!id) return;
      e.preventDefault();
      e.stopPropagation();
      var drawer = document.getElementById('popup-info--' + id);
      if (drawer) openDrawer(drawer);
    });

    // Close: click on [data-popup-info-close]
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-info-close]')) {
        e.preventDefault();
        closeDrawer();
      }
    });

    // Accordion toggles inside our drawers
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-popup-info-drawer] [data-accordion-toggle]');
      if (!toggle) return;
      e.preventDefault();
      var acc = toggle.closest('[data-accordion]');
      if (acc) acc.classList.toggle('is-expanded');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
